// extracted by mini-css-extract-plugin
export var companySectionContent = "NavigationFooter-module--companySectionContent--g2SjB";
export var lastContainer = "NavigationFooter-module--lastContainer--QMtp6";
export var limitWidthOnLargeScreens = "NavigationFooter-module--limitWidthOnLargeScreens--8LQ95";
export var linkDark = "NavigationFooter-module--linkDark--VTOYs";
export var linkLight = "NavigationFooter-module--linkLight--m8Qsh";
export var menuSection = "NavigationFooter-module--menuSection--UpxIh";
export var menuSectionContent = "NavigationFooter-module--menuSectionContent--unAsR";
export var menuSectionHeaderDark = "NavigationFooter-module--menuSectionHeaderDark--wwRkg";
export var menuSectionHeaderLight = "NavigationFooter-module--menuSectionHeaderLight--YXZMS";
export var navFooterContainer = "NavigationFooter-module--navFooterContainer--HAviJ";
export var navMenuContainer = "NavigationFooter-module--navMenuContainer--LPt4B";
export var productSectionContent = "NavigationFooter-module--productSectionContent--gxu2K";
export var resourcesSectionContent = "NavigationFooter-module--resourcesSectionContent--27UiD";
export var socialSectionContent = "NavigationFooter-module--socialSectionContent--YtZww";
export var solutionsSectionContent = "NavigationFooter-module--solutionsSectionContent--RzzG1";